<template>
    <input :id="id" ref="checkbox" type="checkbox" v-model="model" :value="value" />

    <label :class="{'checked': isChecked}" :for="id">
        <slot/>
    </label>
</template>

<script setup>
    import {computed, defineEmits} from "vue";

    const props = defineProps({
        id: {
            type: String,
            required: true
        },
        modelValue: {
            type: [
                Array,
                Boolean
            ]
        },
        value: {
            type: [
                Boolean,
                Object
            ]
        },
    });

    const emit = defineEmits(["update:modelValue"]);

    const model = computed({
        get() {
            return props.modelValue;
        },
        set(value) {
            console.log(value);
            emit("update:modelValue", value);
        }
    });

    const isChecked = computed(() => {
        return props.modelValue.includes(props.value);
    })
</script>